<template>
  <li class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <USkeleton
        class="h-3 w-1/3 mb-1 bg-primary-800/50"
      />

      <div class="flex flex-col gap-1">
        <USkeleton
          class="h-2 w-full bg-primary-800/50"
        />
        <USkeleton
          class="h-2 w-full bg-primary-800/50"
        />
      </div>
    </div>

    <USeparator
      color="primary"
      type="dashed"
    />
  </li>
</template>
